(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-advisor"] && !Shopify.designMode) return;
  try {
    (() => {
    const LEGACY_PROFILE_KEY = 'pinflag_size_advisor_profile_v1';
    const PROFILES_KEY = 'pinflag_size_advisor_profiles_v1';
    const ACTIVE_PROFILE_KEY = 'pinflag_size_advisor_active_id_v1';
    const AUTO_APPLIED = new Set();
    const dataPromiseCache = new Map();
    const recCache = new WeakMap(); // modalRoot -> recomendación actual (para "Editar Medidas" / carrusel)
    const RUN_IDS = new WeakMap(); // modalRoot -> id del último cálculo pedido (ver runRecommendation)
    const MEASURE_SLIDER_SPAN_CM = 20;

    const MONTH_SINGLE_RE = /^(\d+(?:\.\d+)?)\s*M$/i;
    const MONTH_RANGE_RE = /^(\d+)\s*-\s*(\d+)\s*M$/i;
    const YEAR_RE = /^(\d+(?:\.\d+)?)\s*A$/i;

    const DIMENSIONS = [
      { label: 'Pecho', columnRe: /pecho/i, bodyField: 'chest_cm' },
      { label: 'Cintura', columnRe: /cintura/i, bodyField: 'waist_cm' },
      { label: 'Cadera', columnRe: /cadera/i, bodyField: 'hip_cm' },
    ];

    // --- Perfiles guardados (multi-perfil, para varios hijos en la misma sesión) ---
    // Todos los perfiles y cuál está activo se guardan en localStorage, compartidos
    // entre todos los productos/modales (no son por producto).

    function readJsonLS(key) {
      try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    }

    function writeJsonLS(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        return true;
      } catch (error) {
        // localStorage unavailable (ej. modo privado) - el perfil solo dura esta vista.
        return false;
      }
    }

    function removeLS(key) {
      try {
        localStorage.removeItem(key);
      } catch (error) {
        // no-op
      }
    }

    function generateProfileId() {
      return 'p_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    }

    // Migra el formato v1 (un solo perfil) a la lista de perfiles, la primera vez
    // que se carga el modal con el nuevo formato. No pisa datos si ya existe la
    // lista nueva (para no revivir un perfil viejo ya reemplazado/eliminado).
    function migrateLegacyProfile() {
      if (readJsonLS(PROFILES_KEY)) return;
      const legacy = readJsonLS(LEGACY_PROFILE_KEY);
      if (!legacy) return;
      const profile = Object.assign({ id: generateProfileId(), name: 'Mi perfil' }, legacy);
      // Solo se borra el formato viejo si la lista nueva quedó realmente escrita,
      // para no perder el perfil si localStorage rechaza la escritura (cuota/modo privado).
      if (!writeJsonLS(PROFILES_KEY, [profile])) return;
      setActiveProfileId(profile.id);
      removeLS(LEGACY_PROFILE_KEY);
    }

    function getProfiles() {
      return readJsonLS(PROFILES_KEY) || [];
    }

    function saveProfiles(profiles) {
      writeJsonLS(PROFILES_KEY, profiles);
    }

    function getActiveProfileId() {
      try {
        return localStorage.getItem(ACTIVE_PROFILE_KEY);
      } catch (error) {
        return null;
      }
    }

    function setActiveProfileId(id) {
      try {
        if (id) localStorage.setItem(ACTIVE_PROFILE_KEY, id);
        else localStorage.removeItem(ACTIVE_PROFILE_KEY);
      } catch (error) {
        // no-op
      }
    }

    function getActiveProfile() {
      const id = getActiveProfileId();
      if (!id) return null;
      return getProfiles().find((profile) => profile.id === id) || null;
    }

    // El calce se puede cambiar tanto en el formulario del perfil como en "Mis
    // medidas"; se guarda en el perfil para que el cambio siga vigente la próxima
    // vez que se abra el modal, venga de donde venga.
    function persistFitPreference(fitPreference) {
      const id = getActiveProfileId();
      if (!id) return;
      const profiles = getProfiles();
      const profile = profiles.find((p) => p.id === id);
      if (!profile || profile.fitPreference === fitPreference) return;
      profile.fitPreference = fitPreference;
      profile.updatedAt = new Date().toISOString();
      saveProfiles(profiles);
    }

    function getCategoryMeta(sectionId) {
      const node = document.getElementById('SizeAdvisorCategory-' + sectionId);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    function loadJson(url) {
      if (!url) return Promise.resolve(null);
      if (dataPromiseCache.has(url)) return dataPromiseCache.get(url);
      const promise = fetch(url)
        .then((res) => (res.ok ? res.json() : null))
        .catch(() => null);
      dataPromiseCache.set(url, promise);
      return promise;
    }

    // --- Clasificación de la tabla de tallas de la categoría ---

    function tallaColumnKey(columnas) {
      return columnas[0] === 'Rango de edad' ? columnas[1] : columnas[0];
    }

    function classifyGuide(guide) {
      if (!guide || !guide.columnas || !guide.filas || !guide.filas.length) return 'unsupported';
      if (guide.columnas.some((c) => /largo de pie/i.test(c))) return 'shoe';
      const tCol = tallaColumnKey(guide.columnas);
      const values = guide.filas.map((row) => String(row[tCol]).trim());
      if (values.every((v) => MONTH_SINGLE_RE.test(v) || MONTH_RANGE_RE.test(v))) return 'baby';
      if (values.every((v) => YEAR_RE.test(v))) return 'kid';
      return 'unsupported';
    }

    function parseMonths(value) {
      const v = String(value).trim();
      const range = v.match(MONTH_RANGE_RE);
      if (range) return (parseFloat(range[1]) + parseFloat(range[2])) / 2;
      const single = v.match(MONTH_SINGLE_RE);
      return single ? parseFloat(single[1]) : null;
    }

    function availableDimensions(guide) {
      return DIMENSIONS
        .map((dim) => ({ ...dim, columnKey: guide.columnas.find((c) => dim.columnRe.test(c)) }))
        .filter((dim) => dim.columnKey);
    }

    // --- Lectura de celdas de la tabla ---
    // Las celdas vienen como número (54) o como rango en texto ("113 - 117",
    // "3 - 4"); ambas se leen como un intervalo [min, max].

    function parseCellRange(value) {
      if (value == null) return null;
      if (typeof value === 'number') return { min: value, max: value };
      const numbers = (String(value).replace(',', '.').match(/\d+(?:\.\d+)?/g) || []).map(parseFloat);
      if (!numbers.length) return null;
      return { min: Math.min.apply(null, numbers), max: Math.max.apply(null, numbers) };
    }

    function cellMidpoint(value) {
      const range = parseCellRange(value);
      return range ? (range.min + range.max) / 2 : null;
    }

    function averageStep(values) {
      const clean = values.filter((v) => v != null);
      if (clean.length < 2) return null;
      let total = 0;
      for (let i = 1; i < clean.length; i += 1) total += Math.abs(clean[i] - clean[i - 1]);
      const step = total / (clean.length - 1);
      return step > 0 ? step : null;
    }

    // Cuánto cambia en promedio una columna de una talla a la siguiente: es la
    // unidad "1 talla" con la que se normalizan medidas de distinta naturaleza
    // (cm de estatura, cm de contorno, kg de peso) para poder promediarlas.
    function columnStep(guide, columnKey) {
      return averageStep(guide.filas.map((row) => cellMidpoint(row[columnKey])));
    }

    // Más de 2 "tallas típicas" de diferencia de holgura respecto a la talla
    // recomendada se considera fuera de rango aceptable (muy apretado o muy ancho).
    const DEVIATION_BAD_THRESHOLD = 2;

    function evaluateFit(guide, recommendedIndex, index) {
      if (recommendedIndex === -1) return { isBad: false, badDims: [] };
      const recRow = guide.filas[recommendedIndex];
      const row = guide.filas[index];
      const badDims = [];
      availableDimensions(guide).forEach((dim) => {
        const recValue = cellMidpoint(recRow[dim.columnKey]);
        const rowValue = cellMidpoint(row[dim.columnKey]);
        const step = columnStep(guide, dim.columnKey);
        if (recValue == null || rowValue == null || !step) return;
        const deviation = (rowValue - recValue) / step;
        if (Math.abs(deviation) > DEVIATION_BAD_THRESHOLD) badDims.push(dim.bodyField);
      });
      return { isBad: badDims.length > 0, badDims };
    }

    // --- Recomendación: se comparan las medidas del niño/a contra las de la tabla ---
    //
    // La tabla de la categoría (size-guides-data.json) trae, por talla, las medidas
    // que le corresponden a esa talla: estatura, contornos y (en bebé) peso. La
    // recomendación es simplemente la talla cuyas medidas más se acercan a las del
    // niño/a, sin sumar holgura: una niña de 54 de pecho / 53 de cintura / 56 de
    // cadera calza la talla cuya fila dice exactamente eso.
    //
    // Cada medida se compara contra su columna y la diferencia se normaliza por el
    // salto promedio de esa columna entre tallas consecutivas, para poder promediar
    // magnitudes distintas (cm de estatura, cm de contorno, kg de peso) en una sola
    // "distancia en tallas" con signo: positiva = el niño/a es más grande que esa
    // talla, negativa = le sobra.

    const MATCH_FIELDS = [
      { key: 'height_cm', columnRe: /estatura/i },
      { key: 'weight_kg', columnRe: /peso/i },
      { key: 'chest_cm', columnRe: /pecho/i },
      { key: 'waist_cm', columnRe: /cintura/i },
      { key: 'hip_cm', columnRe: /cadera/i },
    ];

    // La preferencia de calce solo desempata los casos intermedios (el niño/a queda
    // entre dos tallas): si sus medidas caen de lleno dentro de una talla, esa gana
    // igual. "Intermedio" es la coincidencia exacta con la tabla.
    const FIT_TARGET_DEVIATION = { tight: 0.25, medium: 0, loose: -0.25 };

    function buildMatchSignals(guide, type) {
      const signals = [];

      MATCH_FIELDS.forEach((field) => {
        const columnKey = guide.columnas.find((c) => field.columnRe.test(c));
        if (!columnKey) return;
        const step = columnStep(guide, columnKey);
        if (!step) return;
        signals.push({ key: field.key, step, rangeOf: (row) => parseCellRange(row[columnKey]) });
      });

      // En bebé la talla ES un rango de edad ("3M", "9 - 12M"), así que la edad
      // entra como una medida más junto a estatura y peso.
      if (type === 'baby') {
        const tCol = tallaColumnKey(guide.columnas);
        const step = averageStep(guide.filas.map((row) => parseMonths(row[tCol])));
        if (step) {
          signals.push({
            key: 'age_months',
            step,
            rangeOf: (row) => {
              const months = parseMonths(row[tCol]);
              return months == null ? null : { min: months, max: months };
            },
          });
        }
      }

      return signals;
    }

    function rowDeviation(signals, measurements, row) {
      const deviations = [];
      signals.forEach((signal) => {
        const measured = measurements[signal.key];
        const range = signal.rangeOf(row);
        if (measured == null || range == null) return;
        if (measured < range.min) deviations.push((measured - range.min) / signal.step);
        else if (measured > range.max) deviations.push((measured - range.max) / signal.step);
        else deviations.push(0);
      });
      if (!deviations.length) return null;
      return deviations.reduce((a, b) => a + b, 0) / deviations.length;
    }

    function recommendIndex(guide, signals, measurements, fitPreference, candidateIndexes) {
      const target = FIT_TARGET_DEVIATION[fitPreference] ?? FIT_TARGET_DEVIATION.medium;
      let bestIndex = -1;
      let bestDist = Infinity;
      candidateIndexes.forEach((idx) => {
        const deviation = rowDeviation(signals, measurements, guide.filas[idx]);
        if (deviation == null) return;
        const dist = Math.abs(deviation - target);
        if (dist < bestDist) {
          bestDist = dist;
          bestIndex = idx;
        }
      });
      return bestIndex;
    }

    // --- Estimación corporal (solo para las barras de comodidad y "Mis medidas") ---

    // Los contornos que se muestran en "Mis medidas" y en las barras de comodidad
    // salen de la MISMA tabla que decide la talla: se interpola la estatura del
    // niño/a contra la columna Estatura. Así los números que ve el usuario son los
    // de la guía de tallas de la tienda (una niña de 90 cm ve 54 / 53 / 56, la fila
    // de la 2A) y no los de una fuente externa que no calza con esa guía.
    function guideBodyRows(guide) {
      const heightColumn = guide.columnas.find((c) => /estatura/i.test(c));
      const dims = availableDimensions(guide);
      if (!heightColumn || !dims.length) return null;
      const rows = guide.filas
        .map((row) => {
          const entry = { height_cm: cellMidpoint(row[heightColumn]) };
          dims.forEach((dim) => { entry[dim.bodyField] = cellMidpoint(row[dim.columnKey]); });
          return entry;
        })
        .filter((entry) => entry.height_cm != null);
      return rows.length ? rows : null;
    }

    function estimateBodyByHeight(rows, heightCm) {
      const chest = estimateFieldByHeight(rows, heightCm, 'chest_cm');
      const waist = estimateFieldByHeight(rows, heightCm, 'waist_cm');
      const hip = estimateFieldByHeight(rows, heightCm, 'hip_cm');
      return { chest_cm: chest, waist_cm: waist, hip_cm: hip };
    }

    function estimateFieldByHeight(rows, heightCm, targetField) {
      const sorted = rows.filter((r) => r.height_cm != null).sort((a, b) => a.height_cm - b.height_cm);
      if (!sorted.length) return null;
      if (heightCm <= sorted[0].height_cm) return sorted[0][targetField];
      if (heightCm >= sorted[sorted.length - 1].height_cm) return sorted[sorted.length - 1][targetField];
      let lo = sorted[0];
      let hi = sorted[sorted.length - 1];
      for (let i = 0; i < sorted.length - 1; i += 1) {
        if (heightCm >= sorted[i].height_cm && heightCm <= sorted[i + 1].height_cm) {
          lo = sorted[i];
          hi = sorted[i + 1];
          break;
        }
      }
      const span = hi.height_cm - lo.height_cm;
      const t = span === 0 ? 0 : (heightCm - lo.height_cm) / span;
      return lo[targetField] + (hi[targetField] - lo[targetField]) * t;
    }

    // --- Orquestación: construye todo lo necesario para renderizar el paso 3 ---

    async function buildRecommendation(sectionId, profile) {
      const categoryMeta = getCategoryMeta(sectionId);
      if (!categoryMeta || !categoryMeta.handle) return { status: 'unsupported' };

      const modalRoot = document.querySelector('[data-size-advisor-modal][data-section="' + sectionId + '"]');
      const sizeGuidesUrl = modalRoot ? modalRoot.dataset.sizeGuidesUrl : null;

      const sizeGuides = await loadJson(sizeGuidesUrl);
      const guide = sizeGuides ? sizeGuides[categoryMeta.handle] : null;
      if (!guide) return { status: 'unsupported' };

      const type = classifyGuide(guide);
      if (type !== 'baby' && type !== 'kid') return { status: 'unsupported' };

      const tCol = tallaColumnKey(guide.columnas);
      const sex = profile.sex || categoryMeta.sex || null;
      const fitPreference = profile.fitPreference || 'medium';

      const signals = buildMatchSignals(guide, type);
      if (!signals.length) return { status: 'unsupported' };

      // Solo las medidas que el usuario entregó. La estimación corporal de la base
      // antropométrica no entra acá - si entrara, la estatura pesaría dos veces.
      const measurements = {
        height_cm: profile.heightCm,
        weight_kg: profile.weightKg,
        age_months: profile.ageMonths,
      };

      // Solo se puede recomendar (y ofrecer en el carrusel) una talla que este
      // producto tenga publicada. Si ninguna de las tallas de la tabla calza con
      // las del selector - otra nomenclatura, o un producto sin selector - se deja
      // la tabla completa: vale más recomendar que quedarse sin recomendación.
      const productSizes = getProductSizes(sectionId);
      const allIndexes = guide.filas.map((row, idx) => idx);
      const availableIndexes = productSizes
        ? allIndexes.filter((idx) => productSizes.has(normalizeSizeLabel(String(guide.filas[idx][tCol]))))
        : [];
      const candidateIndexes = availableIndexes.length ? availableIndexes : allIndexes;

      const recommendedIndex = recommendIndex(guide, signals, measurements, fitPreference, candidateIndexes);
      if (recommendedIndex === -1) return { status: 'unsupported' };

      // Contornos estimados por estatura: se usan para las barras de comodidad y
      // para precargar "Mis medidas" (a donde vuelve "Reiniciar"), no para elegir.
      const bodyRows = type === 'kid' ? guideBodyRows(guide) : null;
      const estimate = bodyRows ? estimateBodyByHeight(bodyRows, profile.heightCm) : null;

      return {
        status: 'ok',
        type,
        guide,
        tCol,
        sex,
        fitPreference,
        profileFitPreference: fitPreference,
        candidateIndexes,
        signals,
        measurements,
        profileMeasurements: measurements,
        estimate,
        originalEstimate: estimate,
        recommendedIndex,
      };
    }

    // --- Aplicar talla al selector de variantes ---
    // El `value` del <input type="radio"> es el option value completo de Shopify
    // (ej. "3 meses"), NO el texto corto que se muestra ("3M"). El texto visible
    // vive en el <label for="..."> asociado, así que hay que comparar contra eso.

    function getRadioLabelText(input) {
      const label = document.querySelector('label[for="' + input.id + '"]');
      if (!label) return input.value;
      let text = '';
      label.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) text += node.textContent;
      });
      return text.trim() || input.value;
    }

    function normalizeSizeLabel(value) {
      return (value || '').trim().toLowerCase();
    }

    function findVariantRadio(sectionId, talla) {
      const scope = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
      if (!scope) return null;
      const targetValue = normalizeSizeLabel(talla);
      return Array.from(scope.querySelectorAll('input[type="radio"]')).find(
        (input) => normalizeSizeLabel(getRadioLabelText(input)) === targetValue
      );
    }

    // Tallas que este producto ofrece de verdad: la tabla de la categoría trae
    // todas las de la línea, pero un producto puede publicarse solo en algunas.
    // El selector de variantes se reemplaza entero en cada cambio de variante, así
    // que se lee al momento de recomendar y no una sola vez al cargar.
    function getProductSizes(sectionId) {
      const scope = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
      if (!scope) return null;
      const radios = Array.from(scope.querySelectorAll('input[type="radio"]'));
      if (!radios.length) return null;
      return new Set(radios.map((input) => normalizeSizeLabel(getRadioLabelText(input))));
    }

    function applyRecommendation(sectionId, talla) {
      const target = findVariantRadio(sectionId, talla);
      if (!target) return { applied: false, reason: 'unavailable' };
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return { applied: true };
    }

    // Aplica la talla y, una vez que el selector de variantes termina de actualizarse
    // (evento async - ver product-info.js), envía el <product-form> real de la
    // sección para hacer un add-to-cart normal (carrito AJAX, notificación, etc).
    function addToCart(sectionId, talla) {
      const applyResult = applyRecommendation(sectionId, talla);

      let submitted = false;
      const doSubmit = () => {
        if (submitted) return;
        submitted = true;
        const productForm = document.querySelector('product-form[data-section-id="' + sectionId + '"]');
        const formEl = productForm && productForm.querySelector('form');
        if (!formEl) return;
        if (formEl.requestSubmit) formEl.requestSubmit();
        else formEl.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      };

      if (applyResult.applied && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event && event.data && event.data.sectionId && event.data.sectionId !== sectionId) return;
          unsubscribe();
          doSubmit();
        });
        setTimeout(doSubmit, 700);
      } else {
        doSubmit();
      }
      return applyResult;
    }

    async function maybeAutoApply(triggerRoot) {
      const sectionId = triggerRoot.dataset.section;
      const productId = triggerRoot.dataset.productId;
      if (AUTO_APPLIED.has(productId)) return;
      const profile = getActiveProfile();
      if (!profile) return;
      const rec = await buildRecommendation(sectionId, profile);
      if (rec.status !== 'ok') return;
      const talla = String(rec.guide.filas[rec.recommendedIndex][rec.tCol]).trim();
      applyRecommendation(sectionId, talla);
      AUTO_APPLIED.add(productId);
    }

    // --- UI: navegación de pasos ---

    function setDots(modalRoot, step) {
      modalRoot.querySelectorAll('[data-size-advisor-dots]').forEach((dotsEl) => {
        dotsEl.querySelectorAll('span').forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === step - 1);
        });
      });
    }

    function showStep(modalRoot, stepName) {
      modalRoot.querySelectorAll('[data-size-advisor-step]').forEach((stepEl) => {
        stepEl.hidden = stepEl.dataset.sizeAdvisorStep !== stepName;
      });
      modalRoot.querySelector('[data-size-advisor-unsupported]').hidden = true;
    }

    // --- Wizard: pantallas dentro del paso "profile" (lista / sexo / medidas) ---
    // direction 'forward' desliza la pantalla entrante desde la derecha (avanzar),
    // 'back' desde la izquierda (retroceder) - le da al flujo de crear/editar un
    // perfil la sensación de wizard con "pantallas" en vez de un simple show/hide.
    function showScreen(modalRoot, screenName, direction) {
      modalRoot.querySelectorAll('[data-size-advisor-screen]').forEach((screenEl) => {
        const isTarget = screenEl.dataset.sizeAdvisorScreen === screenName;
        screenEl.hidden = !isTarget;
        screenEl.classList.remove('is-sliding-in-left', 'is-sliding-in-right');
        if (isTarget) {
          void screenEl.offsetWidth;
          screenEl.classList.add(direction === 'back' ? 'is-sliding-in-left' : 'is-sliding-in-right');
        }
      });

      modalRoot.querySelectorAll('[data-size-advisor-dots]').forEach((dotsEl) => {
        dotsEl.hidden = screenName === 'list';
      });
      setDots(modalRoot, screenName === 'sex' ? 1 : 2);

      // "Atrás" solo tiene sentido en la pantalla de sexo si hay una lista de
      // perfiles a la que volver - se recalcula acá (y no solo al crear un perfil
      // nuevo) para que también quede bien si se llega a esta pantalla desde
      // "Editar" -> "Atrás".
      if (screenName === 'sex') {
        const backToListBtn = modalRoot.querySelector('[data-size-advisor-back-to-list]');
        if (backToListBtn) backToListBtn.hidden = getProfiles().length === 0;
      }
    }

    function showUnsupported(modalRoot) {
      modalRoot.querySelectorAll('[data-size-advisor-step]').forEach((stepEl) => {
        stepEl.hidden = true;
      });
      modalRoot.querySelector('[data-size-advisor-unsupported]').hidden = false;
    }

    // --- UI: toggle de unidad para la edad (único que queda) ---

    // form.reset() no toca el toggle (no es un control del form), así que hay que
    // volverlo a su estado inicial a mano al cargar o limpiar el formulario.
    function setAgeUnit(modalRoot, unit) {
      const toggle = modalRoot.querySelector('[data-unit-toggle="age"]');
      toggle.dataset.currentUnit = unit;
      toggle.querySelectorAll('button').forEach((b) => b.classList.toggle('is-active', b.dataset.unit === unit));
    }

    function wireAgeUnitToggle(modalRoot) {
      const toggle = modalRoot.querySelector('[data-unit-toggle="age"]');
      const input = modalRoot.querySelector('[data-size-advisor-age]');
      setAgeUnit(modalRoot, 'years');

      toggle.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => {
          const newUnit = btn.dataset.unit;
          const oldUnit = toggle.dataset.currentUnit;
          if (newUnit === oldUnit) return;

          const raw = parseFloat(input.value);
          if (!Number.isNaN(raw)) {
            const months = oldUnit === 'years' ? raw * 12 : raw;
            const displayValue = newUnit === 'years' ? months / 12 : months;
            input.value = Math.round(displayValue * 10) / 10;
          }

          toggle.dataset.currentUnit = newUnit;
          toggle.querySelectorAll('button').forEach((b) => b.classList.toggle('is-active', b === btn));
        });
      });
    }

    function readAgeMonths(modalRoot) {
      const toggle = modalRoot.querySelector('[data-unit-toggle="age"]');
      const input = modalRoot.querySelector('[data-size-advisor-age]');
      const raw = parseFloat(input.value);
      if (Number.isNaN(raw)) return null;
      return toggle.dataset.currentUnit === 'years' ? raw * 12 : raw;
    }

    // --- UI: sliders de comodidad (paso 3, solo lectura) ---

    // La tabla trae la medida corporal que corresponde a cada talla, así que la
    // barra se centra en la coincidencia exacta: el marcador queda al medio cuando
    // la medida del niño/a es la de la talla, y se corre hacia APRETADO o ANCHO a
    // razón de media barra por talla de diferencia.
    const SLIDER_SPAN_STEPS = 2;

    function diffToPosition(diffCm, spanCm) {
      const clamped = Math.min(Math.max(diffCm, -spanCm), spanCm);
      return ((clamped + spanCm) / (2 * spanCm)) * 100;
    }

    function renderSliders(container, guide, estimate, row, badDims) {
      container.innerHTML = '';
      if (!estimate) return;
      const badSet = new Set(badDims || []);

      availableDimensions(guide).forEach((dim) => {
        const rowValue = cellMidpoint(row[dim.columnKey]);
        const bodyValue = estimate[dim.bodyField];
        const step = columnStep(guide, dim.columnKey);
        if (rowValue == null || bodyValue == null || !step) return;
        const position = diffToPosition(rowValue - bodyValue, step * SLIDER_SPAN_STEPS);
        const isBad = badSet.has(dim.bodyField);

        const wrapper = document.createElement('div');
        wrapper.className = 'size-advisor-slider';
        wrapper.innerHTML =
          '<span class="size-advisor-slider__label">' + dim.label + '</span>' +
          '<div class="size-advisor-slider__track' + (isBad ? ' is-bad' : '') + '">' +
          '<span>AJUSTADO</span>' +
          '<div class="size-advisor-slider__marker" style="left: ' + position + '%"></div>' +
          '<span>ANCHO</span>' +
          '</div>';
        container.appendChild(wrapper);
      });
    }

    // --- UI: carrusel de tallas alternativas ---

    function renderAltSizes(modalRoot, rec, selectedIndex, onSelect) {
      const listEl = modalRoot.querySelector('[data-size-advisor-alt-list]');
      const wrapperEl = modalRoot.querySelector('[data-size-advisor-alt]');
      const prevBtn = modalRoot.querySelector('[data-alt-prev]');
      const nextBtn = modalRoot.querySelector('[data-alt-next]');
      const { guide, tCol, recommendedIndex, candidateIndexes } = rec;

      if (candidateIndexes.length <= 1) {
        wrapperEl.hidden = true;
        return;
      }
      wrapperEl.hidden = false;

      // El carrusel se mueve entre las tallas que el producto tiene, no entre las
      // filas de la tabla: saltarse una talla no publicada es lo correcto acá.
      const position = candidateIndexes.indexOf(selectedIndex);
      const windowIndexes = [position - 1, position, position + 1]
        .filter((pos) => pos >= 0 && pos < candidateIndexes.length)
        .map((pos) => candidateIndexes[pos]);

      listEl.innerHTML = '';
      windowIndexes.forEach((idx) => {
        const talla = String(guide.filas[idx][tCol]).trim();
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'size-advisor-alt__item';
        if (idx === selectedIndex) btn.classList.add('is-selected');
        const fit = evaluateFit(guide, recommendedIndex, idx);
        if (fit.isBad) {
          btn.classList.add('is-not-recommended');
        } else if (idx === recommendedIndex) {
          btn.classList.add('is-recommended');
        }
        btn.textContent = talla;
        btn.addEventListener('click', () => onSelect(idx));
        listEl.appendChild(btn);
      });

      prevBtn.disabled = position <= 0;
      nextBtn.disabled = position >= candidateIndexes.length - 1;
      prevBtn.onclick = () => onSelect(candidateIndexes[Math.max(0, position - 1)]);
      nextBtn.onclick = () => onSelect(candidateIndexes[Math.min(candidateIndexes.length - 1, position + 1)]);
    }

    // --- Renderizado principal del paso 3 ---

    function renderResultForIndex(modalRoot, sectionId, rec, index) {
      const { guide, tCol, estimate, recommendedIndex } = rec;
      const row = guide.filas[index];
      const talla = String(row[tCol]).trim();

      const fit = evaluateFit(guide, recommendedIndex, index);

      const sizeEl = modalRoot.querySelector('[data-size-advisor-result-size]');
      sizeEl.textContent = talla;
      sizeEl.classList.remove('is-updating');
      void sizeEl.offsetWidth;
      sizeEl.classList.add('is-updating');

      const headlineEl = modalRoot.querySelector('[data-size-advisor-result-headline]');
      headlineEl.hidden = false;
      headlineEl.classList.toggle('is-bad', fit.isBad);
      headlineEl.querySelector('.size-advisor-result__title').textContent = fit.isBad
        ? 'No es recomendable'
        : index === recommendedIndex
          ? 'Es la talla recomendada'
          : 'Buena opción';

      renderSliders(modalRoot.querySelector('[data-size-advisor-sliders]'), guide, estimate, row, fit.badDims);
      renderAltSizes(modalRoot, rec, index, (newIndex) => renderResultForIndex(modalRoot, sectionId, rec, newIndex));

      modalRoot.querySelector('[data-size-advisor-add-to-cart]').dataset.talla = talla;
    }

    async function runRecommendation(modalRoot, sectionId, profile) {
      // Cambiar de perfil dispara un cálculo async; si el usuario alcanza a elegir
      // otro antes de que termine el anterior, se descarta el resultado viejo para
      // que no pise en pantalla al del perfil recién elegido.
      const runId = (RUN_IDS.get(modalRoot) || 0) + 1;
      RUN_IDS.set(modalRoot, runId);
      const rec = await buildRecommendation(sectionId, profile);
      if (RUN_IDS.get(modalRoot) !== runId) return;
      recCache.set(modalRoot, rec.status === 'ok' ? rec : null);
      if (rec.status !== 'ok') {
        showUnsupported(modalRoot);
        return;
      }
      showStep(modalRoot, 'result');
      renderResultForIndex(modalRoot, sectionId, rec, rec.recommendedIndex);
    }

    // --- Paso "Mis medidas" ---

    function buildMeasureFieldRow(dim, valueCm) {
      const row = document.createElement('div');
      row.className = 'size-advisor-measure__field';
      row.dataset.bodyField = dim.bodyField;
      row.dataset.prefill = valueCm.toFixed(1);
      const min = Math.max(0, Math.round(valueCm - MEASURE_SLIDER_SPAN_CM));
      const max = Math.round(valueCm + MEASURE_SLIDER_SPAN_CM);
      row.innerHTML =
        '<div class="size-advisor-measure__field-top">' +
        '<label>' + dim.label + '</label>' +
        '<div class="size-advisor-measure__number-row">' +
        '<input type="number" step="0.5" min="' + min + '" max="' + max + '" value="' + valueCm.toFixed(1) + '">' +
        '<span>cm</span>' +
        '</div>' +
        '</div>' +
        '<input type="range" min="' + min + '" max="' + max + '" step="0.5" value="' + valueCm.toFixed(1) + '">';

      const range = row.querySelector('input[type="range"]');
      const number = row.querySelector('input[type="number"]');
      range.addEventListener('input', () => { number.value = range.value; });
      number.addEventListener('input', () => { range.value = number.value; });
      return row;
    }

    function setFitSelection(row, fitPreference) {
      row.querySelectorAll('[data-fit-option]').forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.fitOption === (fitPreference || 'medium'));
      });
    }

    function readFitSelection(row) {
      const active = row.querySelector('[data-fit-option].is-active');
      return active ? active.dataset.fitOption : 'medium';
    }

    function openMeasureStep(modalRoot, rec, useOriginal) {
      const fieldsEl = modalRoot.querySelector('[data-size-advisor-measure-fields]');
      fieldsEl.innerHTML = '';

      const source = useOriginal ? rec.originalEstimate : rec.estimate;
      availableDimensions(rec.guide)
        .filter((dim) => source[dim.bodyField] != null)
        .forEach((dim) => {
          fieldsEl.appendChild(buildMeasureFieldRow(dim, source[dim.bodyField]));
        });

      setFitSelection(modalRoot.querySelector('[data-size-advisor-measure-fit-row]'), rec.fitPreference);

      showStep(modalRoot, 'measure');
    }

    function submitMeasureStep(modalRoot, sectionId, rec) {
      const fieldsEl = modalRoot.querySelector('[data-size-advisor-measure-fields]');
      const edited = {};
      // Los contornos que el usuario mide a mano mandan sobre todo lo demás: un
      // contorno real describe el cuerpo mejor que la estatura, que solo servía
      // para estimarlo. Los campos que quedaron en el valor precargado siguen
      // siendo esa estimación, así que no cuentan como medida ingresada (y por eso
      // entrar y salir de esta pantalla sin tocar nada no cambia la talla).
      const userEdited = {};
      fieldsEl.querySelectorAll('.size-advisor-measure__field').forEach((fieldRow) => {
        const value = parseFloat(fieldRow.querySelector('input[type="number"]').value);
        if (Number.isNaN(value)) return;
        edited[fieldRow.dataset.bodyField] = value;
        const prefill = parseFloat(fieldRow.dataset.prefill);
        if (Number.isNaN(prefill) || Math.abs(value - prefill) > 0.05) {
          userEdited[fieldRow.dataset.bodyField] = value;
        }
      });

      rec.estimate = { ...rec.estimate, ...edited };
      rec.measurements = Object.keys(userEdited).length ? userEdited : rec.profileMeasurements;
      rec.fitPreference = readFitSelection(modalRoot.querySelector('[data-size-advisor-measure-fit-row]'));
      persistFitPreference(rec.fitPreference);

      const newIndex = recommendIndex(rec.guide, rec.signals, rec.measurements, rec.fitPreference, rec.candidateIndexes);
      if (newIndex === -1) return;
      rec.recommendedIndex = newIndex;

      showStep(modalRoot, 'result');
      renderResultForIndex(modalRoot, sectionId, rec, newIndex);
    }

    // --- Perfil guardado: saltar directo al resultado si ya existe ---

    // Al limpiar el formulario se vuelve a la sugerencia de sexo del producto
    // (dataset.suggestedSex, sacada de los tags), no a "ninguno".
    function setSexSelection(modalRoot, sex) {
      modalRoot.querySelectorAll('[data-sex-option]').forEach((btn) => {
        btn.classList.toggle('is-active', Boolean(sex) && btn.dataset.sexOption === sex);
      });
    }

    function setFormError(modalRoot, message) {
      const errorEl = modalRoot.querySelector('[data-size-advisor-error]');
      errorEl.textContent = message || '';
      errorEl.hidden = !message;
    }

    function fillFormFromProfile(modalRoot, profile) {
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      setFormError(modalRoot, '');
      formEl.dataset.editingId = profile.id || '';
      modalRoot.querySelector('[data-size-advisor-name]').value = profile.name || '';
      modalRoot.querySelector('[data-size-advisor-height]').value = profile.heightCm;
      modalRoot.querySelector('[data-size-advisor-weight]').value = profile.weightKg;
      setAgeUnit(modalRoot, 'years');
      modalRoot.querySelector('[data-size-advisor-age]').value = Math.round((profile.ageMonths / 12) * 10) / 10;
      setSexSelection(modalRoot, profile.sex);
      setFitSelection(modalRoot.querySelector('[data-size-advisor-fit-row]'), profile.fitPreference);
    }

    // --- Panel de perfiles guardados: listar, seleccionar, editar, eliminar ---

    // El glifo (✎ / ✕) queda aria-hidden: es decorativo y los lectores de pantalla
    // lo leerían como un símbolo suelto - el texto real va en el aria-label.
    function buildProfileIconButton(className, glyph, label, onClick) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = className;
      btn.setAttribute('aria-label', label);
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = glyph;
      btn.appendChild(icon);
      btn.addEventListener('click', onClick);
      return btn;
    }

    function renderProfilesPanel(modalRoot, sectionId) {
      const listEl = modalRoot.querySelector('[data-size-advisor-profiles-list]');
      const profiles = getProfiles();
      const activeId = getActiveProfileId();

      listEl.innerHTML = '';

      if (!profiles.length) return;

      profiles.forEach((profile) => {
        const isActive = profile.id === activeId;
        const displayName = profile.name || 'Sin nombre';
        const item = document.createElement('div');
        item.className = 'size-advisor-profiles__item' + (isActive ? ' is-active' : '');

        const selectBtn = document.createElement('button');
        selectBtn.type = 'button';
        selectBtn.className = 'size-advisor-profiles__select';
        selectBtn.textContent = displayName;
        if (isActive) selectBtn.setAttribute('aria-current', 'true');
        selectBtn.addEventListener('click', () => selectProfile(modalRoot, sectionId, profile.id));
        item.appendChild(selectBtn);

        item.appendChild(
          buildProfileIconButton('size-advisor-profiles__edit', '✎', 'Editar el perfil ' + displayName, () =>
            openEditProfileForm(modalRoot, profile)
          )
        );
        item.appendChild(
          buildProfileIconButton('size-advisor-profiles__delete', '✕', 'Eliminar el perfil ' + displayName, () =>
            deleteProfile(modalRoot, sectionId, profile.id)
          )
        );

        listEl.appendChild(item);
      });
    }

    function selectProfile(modalRoot, sectionId, id) {
      const profile = getProfiles().find((p) => p.id === id);
      if (!profile) return;
      setActiveProfileId(id);
      fillFormFromProfile(modalRoot, profile);
      showStep(modalRoot, 'profile');
      showScreen(modalRoot, 'form', 'forward');
      renderProfilesPanel(modalRoot, sectionId);
      modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = false;
      runRecommendation(modalRoot, sectionId, profile);
    }

    // Primera pantalla del wizard de creación: elegir sexo. "Atrás" solo tiene
    // sentido si hay una lista de perfiles a la que volver.
    function openNewProfileForm(modalRoot, direction) {
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      formEl.reset();
      formEl.dataset.editingId = '';
      setFormError(modalRoot, '');
      setAgeUnit(modalRoot, 'years');
      setSexSelection(modalRoot, modalRoot.dataset.suggestedSex);
      setFitSelection(modalRoot.querySelector('[data-size-advisor-fit-row]'), 'medium');

      modalRoot.querySelector('[data-size-advisor-sex-next]').disabled = !modalRoot.dataset.suggestedSex;
      // Con perfiles guardados, "Cambiar de perfil" es otra salida para volver a la lista.
      modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = getProfiles().length === 0;
      showStep(modalRoot, 'profile');
      showScreen(modalRoot, 'sex', direction || 'forward');
    }

    // Editar un perfil existente ya conoce el sexo: salta directo a la pantalla
    // de medidas en vez de pasar de nuevo por la de sexo.
    function openEditProfileForm(modalRoot, profile) {
      fillFormFromProfile(modalRoot, profile);
      modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = false;
      showStep(modalRoot, 'profile');
      showScreen(modalRoot, 'form', 'forward');
    }

    // Vista "elige un perfil": solo la lista (salvo que no haya ninguno guardado,
    // en cuyo caso no hay nada que elegir y se salta directo a crear el primero).
    function showProfilesList(modalRoot, sectionId, direction) {
      renderProfilesPanel(modalRoot, sectionId);
      if (!getProfiles().length) {
        openNewProfileForm(modalRoot, direction);
        return;
      }
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      formEl.dataset.editingId = '';
      setFormError(modalRoot, '');
      setSexSelection(modalRoot, modalRoot.dataset.suggestedSex);
      modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = true;
      showStep(modalRoot, 'profile');
      showScreen(modalRoot, 'list', direction || 'back');
    }

    function deleteProfile(modalRoot, sectionId, id) {
      const profile = getProfiles().find((p) => p.id === id);
      if (!profile) return;
      if (!window.confirm('¿Eliminar el perfil ' + (profile.name || 'sin nombre') + '?')) return;
      saveProfiles(getProfiles().filter((p) => p.id !== id));

      // Si el formulario estaba editando justo este perfil, soltar el id: si no,
      // el siguiente "Siguiente" lo revive como perfil nuevo.
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      if (formEl.dataset.editingId === id) {
        formEl.dataset.editingId = '';
      }

      // Al borrar el perfil activo no se elige otro por el usuario: se vuelve a la
      // lista para que elija, en vez de saltar a la recomendación de un perfil
      // cualquiera.
      if (getActiveProfileId() === id) {
        setActiveProfileId(null);
        showProfilesList(modalRoot, sectionId);
        return;
      }
      renderProfilesPanel(modalRoot, sectionId);
    }

    function initModal(modalRoot, sectionId, categoryMeta) {
      const sexRow = modalRoot.querySelector('[data-size-advisor-sex-row]');
      const formEl = modalRoot.querySelector('[data-size-advisor-form]');
      const switchBtn = modalRoot.querySelector('[data-size-advisor-switch-profile]');
      const sexNextBtn = modalRoot.querySelector('[data-size-advisor-sex-next]');

      if (categoryMeta && categoryMeta.sex) {
        modalRoot.dataset.suggestedSex = categoryMeta.sex;
        setSexSelection(modalRoot, categoryMeta.sex);
      }

      // Elegir sexo solo marca la selección - avanzar a la pantalla de medidas
      // es una acción explícita del usuario vía el botón "Siguiente".
      sexRow.querySelectorAll('[data-sex-option]').forEach((btn) => {
        btn.addEventListener('click', () => {
          sexRow.querySelectorAll('[data-sex-option]').forEach((b) => b.classList.toggle('is-active', b === btn));
          sexNextBtn.disabled = false;
        });
      });

      sexNextBtn.addEventListener('click', () => {
        showScreen(modalRoot, 'form', 'forward');
        modalRoot.querySelector('[data-size-advisor-name]').focus();
      });

      modalRoot.querySelector('[data-size-advisor-back-to-list]').addEventListener('click', () => {
        showProfilesList(modalRoot, sectionId, 'back');
      });

      modalRoot.querySelector('[data-size-advisor-back-to-sex]').addEventListener('click', () => {
        showScreen(modalRoot, 'sex', 'back');
      });

      wireAgeUnitToggle(modalRoot);

      const fitRow = modalRoot.querySelector('[data-size-advisor-fit-row]');
      const measureFitRow = modalRoot.querySelector('[data-size-advisor-measure-fit-row]');
      [fitRow, measureFitRow].forEach((row) => {
        row.querySelectorAll('[data-fit-option]').forEach((btn) => {
          btn.addEventListener('click', () => setFitSelection(row, btn.dataset.fitOption));
        });
      });

      formEl.addEventListener('submit', (event) => {
        event.preventDefault();
        const name = modalRoot.querySelector('[data-size-advisor-name]').value.trim();
        const heightCm = parseFloat(modalRoot.querySelector('[data-size-advisor-height]').value);
        const weightKg = parseFloat(modalRoot.querySelector('[data-size-advisor-weight]').value);
        const ageMonths = readAgeMonths(modalRoot);
        const sexBtn = sexRow.querySelector('.is-active');
        const fitBtn = fitRow.querySelector('.is-active');

        // ageMonths se compara contra null y no por falsy: 0 meses (recién nacido)
        // es un valor válido en las categorías de bebé.
        if (!heightCm || !weightKg || ageMonths == null) {
          setFormError(modalRoot, 'Completa la altura, el peso y la edad para continuar.');
          return;
        }

        const editingId = formEl.dataset.editingId;
        const profiles = getProfiles();
        // Sin nombre no hay nada que distinguir - varios perfiles "Sin nombre"
        // son válidos, así que el chequeo de duplicado solo aplica si escribió uno.
        const nameTaken = name && profiles.some(
          (p) => p.id !== editingId && (p.name || '').trim().toLowerCase() === name.toLowerCase()
        );
        if (nameTaken) {
          setFormError(modalRoot, 'Ya tienes un perfil con ese nombre. Usa otro para poder distinguirlos.');
          return;
        }
        setFormError(modalRoot, '');

        let profile = editingId ? profiles.find((p) => p.id === editingId) : null;
        if (!profile) {
          profile = { id: generateProfileId() };
          profiles.push(profile);
        }
        profile.name = name;
        profile.heightCm = heightCm;
        profile.weightKg = weightKg;
        profile.ageMonths = ageMonths;
        profile.sex = sexBtn ? sexBtn.dataset.sexOption : null;
        profile.fitPreference = fitBtn ? fitBtn.dataset.fitOption : 'medium';
        profile.updatedAt = new Date().toISOString();

        saveProfiles(profiles);
        setActiveProfileId(profile.id);
        formEl.dataset.editingId = profile.id;
        switchBtn.hidden = false;
        renderProfilesPanel(modalRoot, sectionId);
        runRecommendation(modalRoot, sectionId, profile);
      });

      modalRoot.querySelector('[data-size-advisor-profiles-add]').addEventListener('click', () => {
        openNewProfileForm(modalRoot, 'forward');
      });

      switchBtn.addEventListener('click', () => {
        showProfilesList(modalRoot, sectionId, 'back');
      });

      modalRoot.querySelector('[data-size-advisor-edit]').addEventListener('click', () => {
        const rec = recCache.get(modalRoot);
        if (rec && rec.type === 'kid') {
          openMeasureStep(modalRoot, rec, false);
        } else {
          showStep(modalRoot, 'profile');
          showScreen(modalRoot, 'form', 'back');
        }
      });

      modalRoot.querySelector('[data-size-advisor-measure-reset]').addEventListener('click', () => {
        const rec = recCache.get(modalRoot);
        if (!rec) return;
        rec.estimate = rec.originalEstimate;
        rec.measurements = rec.profileMeasurements;
        rec.fitPreference = rec.profileFitPreference;
        persistFitPreference(rec.fitPreference);
        openMeasureStep(modalRoot, rec, true);
      });

      modalRoot.querySelector('[data-size-advisor-measure-submit]').addEventListener('click', () => {
        const rec = recCache.get(modalRoot);
        if (rec) submitMeasureStep(modalRoot, sectionId, rec);
      });

      modalRoot.querySelector('[data-size-advisor-add-to-cart]').addEventListener('click', (event) => {
        const talla = event.currentTarget.dataset.talla;
        if (!talla) return;
        addToCart(sectionId, talla);
      });
    }

    function initModals() {
      migrateLegacyProfile();
      document.querySelectorAll('[data-size-advisor-modal]').forEach((modalRoot) => {
        if (modalRoot.dataset.initialized === 'true') return;
        modalRoot.dataset.initialized = 'true';
        const sectionId = modalRoot.dataset.section;
        const categoryMeta = getCategoryMeta(sectionId);

        initModal(modalRoot, sectionId, categoryMeta);

        const activeProfile = getActiveProfile();
        if (activeProfile) {
          renderProfilesPanel(modalRoot, sectionId);
          fillFormFromProfile(modalRoot, activeProfile);
          showStep(modalRoot, 'profile');
          showScreen(modalRoot, 'form', 'forward');
          modalRoot.querySelector('[data-size-advisor-switch-profile]').hidden = false;
          runRecommendation(modalRoot, sectionId, activeProfile);
        } else {
          showProfilesList(modalRoot, sectionId, 'forward');
        }
      });
    }

    function initTriggers() {
      document.querySelectorAll('[data-size-advisor-trigger]').forEach((triggerRoot) => {
        maybeAutoApply(triggerRoot);
        if (triggerRoot.dataset.initialized === 'true') return;
        triggerRoot.dataset.initialized = 'true';
      });
    }

    initModals();
    initTriggers();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => initTriggers());
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
